<template>
  <div class="d-inline-block">
    <b-button
      :variant="variant"
      size="sm"
      @click="onClickTrackingStatus"
      :disabled="busy || disabled"
      :title="trans('press_to_change')"
    >
      <i v-if="busy" class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ text }}
    </b-button>
    <span v-if="error" class="text-danger">
      {{ error }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      organization: Object,
      value: Object, // booking with tracking_status taken from invoice_item
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        tracking_status: this.value.tracking_status,
      }
    },
    computed: {
      variant() {
        if (this.tracking_status == 'absent') return 'danger'
        else if (this.tracking_status == 'present') return 'success'
        else if (!this.tracking_status) return 'secondary'
        let parts = this.tracking_status.split('::')
        return parts[0]
      },
      text() {
        if (this.tracking_status == 'absent') return trans(this.tracking_status)
        else if (this.tracking_status == 'present') return trans(this.tracking_status)
        else if (!this.tracking_status) return '?'
        let parts = this.tracking_status.split('::')
        return parts[1] || '?'
      },
    },
    methods: {
      onClickTrackingStatus(e) {
        e.stopImmediatePropagation()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/booking_invoice_item/${this.value.invoice_item_id}/tracking/next`
        axios.patch(url)
        .then(response => {
          this.busy = false
          let booking = response.data.booking
          booking.invoice_item_id = response.data.id
          booking.tracking_status = response.data.tracking_status
          this.tracking_status = booking.tracking_status
          this.$emit('input', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
  }
</script>